import { FC, useState } from "react";
import { Typography, Button, Box, Grid } from "@material-ui/core";
import { MyGainsProps } from "../../interfaces";

import WithDrawGainsModal from "../Modals/WithDrawGainsModal";
import RelockGainsModal from "../Modals/RelockGainsModal";
import { NetworkName } from "../../store/Wallet/WalletFunction";
import moment from "moment";
import { appConfig } from "../../config";

const MyGainsMobileList: FC<MyGainsProps> = (props) => {
  const [openGainsWithdrawModal, setOpenGainsWithdrawModal] = useState(false);
  const [openGainsRelockModal, setOpenGainsRelockModal] = useState(false);

  const handleWithDraw = () => {
    setOpenGainsWithdrawModal(true);
  };

  const handleRelock = () => {
    setOpenGainsRelockModal(true);
  };

  const timeBetweenMonths = moment
    .duration(moment(props.expiresAt).diff(moment()))
    .asMonths()
    .toFixed();
  const timeBetweenDays = moment
    .duration(moment(props.expiresAt).diff(moment()))
    .asDays()
    .toFixed();
  const timeBetweenHours = moment
    .duration(moment(props.expiresAt).diff(moment()))
    .asHours()
    .toFixed();

  const isRelockDisabled = props.scVersion !== Number(appConfig.latestLockContractVersion)
  
  return (
    <>
      <Grid item sm={6} xs={12}>
        <Box
          display="flex"
          p={2}
          className="mobielViewMain"
          justifyContent="space-between"
          flexDirection="column"
          mb="12px"
          mt="12px"
        >
          <Box
            display="flex"
            mb="12px"
            justifyContent="center"
            alignItems="center"
          >
            <Box display="flex" flexGrow="1" alignItems="center">
              <Typography variant="h6" color="secondary">
                Duration
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6" color="primary">
              { props.duration + " "}
              {Number(props.duration) === 1
                ? "Month"
                : "Months"}
              </Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            p={2}
            mb="6px"
            justifyContent="space-between"
            className="mobileContent"
          >
            <Box flexGrow="1">
              <Typography variant="subtitle1" className="textColor fw-normal">
                Status
              </Typography>
            </Box>
            <Box className="mobileViewProgress">
              <Typography
                align="right"
                variant="subtitle1"
                color="secondary"
                className="fw-normal"
              >
                {props.status.toUpperCase() === 'AWAITING_LOCK' ? 'PENDING' : props.status.toUpperCase()}
              </Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            p={2}
            mb="6px"
            justifyContent="space-between"
            className="mobileContent"
          >
            <Box flexGrow="1">
              <Typography variant="subtitle1" className="textColor fw-normal">
                Token
              </Typography>
            </Box>
            <Box className="mobileViewProgress">
              <Typography
                align="right"
                variant="subtitle1"
                color="secondary"
                className="fw-normal"
              >
                {props.amount}
              </Typography>
            </Box>
          </Box>

          <Box
            display="flex"
            p={2}
            mb="6px"
            justifyContent="space-between"
            className="mobileContent"
          >
            <Box flexGrow="1">
              <Typography variant="subtitle1" className="textColor fw-normal">
                Address
              </Typography>
            </Box>
            <Box className="mobileViewProgress">
              <Typography align="right" variant="subtitle1" color="primary">
                {props.address?.length > 5
                  ? props.address?.substr(0, 6) +
                    "..." +
                    props.address?.substr(
                      props.address?.length - 4,
                      props.address?.length
                    )
                  : props.address}
              </Typography>
              <br />
              <Typography component="span" color="secondary" variant="caption">
                {NetworkName(props.networkId)}
              </Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            p={2}
            mb="6px"
            justifyContent="space-between"
            className="mobileContent"
          >
            <Box flexGrow="1">
              <Typography variant="subtitle1" className="textColor fw-normal">
                Tickets
              </Typography>
            </Box>
            <Box className="mobileViewProgress">
              <Typography align="right" variant="subtitle1" color="primary">
                {props.Tickets}
              </Typography>
            </Box>
          </Box>

          <Box display="flex" mt={1}>
            <Box component="span" flexGrow={1}>
              <Button
                variant={props.status === "staked" ? "contained" : "outlined"}
                color="secondary"
                className="mr-8 res-button"
                classes={{ label: "fs-12" }}
                disabled={
                  props.status === "staked" || props.status === "awaiting_lock" || props.status === "unlocked"
                }
                onClick={handleWithDraw}
              >
                Withdraw
              </Button>
              {openGainsWithdrawModal && (
                <WithDrawGainsModal
                  open={openGainsWithdrawModal}
                  setOpen={setOpenGainsWithdrawModal}
                  subscriptionId={props.id}
                  address={props.address}
                  amount={props.amount}
                  network={props.networkId}
                  scVersion={props.scVersion}
                />
              )}
            </Box>
            <Box component="span" flexGrow={1}>
              <Button
                variant="contained"
                color="secondary"
                className="mr-8 res-button"
                classes={{ label: "fs-12" }}
                disabled={
                  props.status === "staked" || props.status === "awaiting_lock" || props.status === "unlocked" || isRelockDisabled
                }
                onClick={handleRelock}
              >
                Restake
              </Button>
              {openGainsRelockModal && (
                <RelockGainsModal
                  open={openGainsRelockModal}
                  setOpen={setOpenGainsRelockModal}
                  subscriptionId={props.id}
                  duration={props.duration}
                  amount={props.amount}
                  tickets={props.Tickets}
                  address={props.address}
                  network={props.networkId}
                  scVersion={props.scVersion}
                />
              )}
              <Typography
                variant="subtitle1"
                className="text-darkslate fw-normal mt-4"
                align="center"
              >
                {props.status === "staked"
                ? `GAINS unstake in ${
                    (Number(timeBetweenMonths) > 1)
                      ? timeBetweenMonths + " Months"
                      : (Number(timeBetweenDays) > 1)
                        ? timeBetweenDays + " Days"
                        : timeBetweenHours + " Hours"
                  }
                `
                : props.status === "available" &&
                  `Restake ${props.Tickets} ticket(s)`}
                {
                  props.status === "unlocked"
                    ? `GAINS withdrawn`
                    : ''
                }
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default MyGainsMobileList;
